export const ENV = {
  names: {
    develop: 'develop',
    staging: 'staging',
    production: 'production',
  },
  routes: {
    GOOGLE_AUTH_ROUTE: '/auth/google',
  },
};
